import * as loadingStates from '@coconut/constants/loadingState';

export const types = {
  FETCH_TUTOR_STATISTIC: 'FETCH_TUTOR_STATISTIC',
  FETCH_TUTOR_STATISTIC_SUCCESS: 'FETCH_TUTOR_STATISTIC_SUCCESS',
  FETCH_TUTOR_STATISTIC_FAILED: 'FETCH_TUTOR_STATISTIC_FAILED',
};

export const fetchTutorStatistic = (tutorID) => ({
  type: types.FETCH_TUTOR_STATISTIC,
  payload: {
    tutorID,
  },
});

export const fetchTutorStatisticSuccess = (topSubjects) => ({
  type: types.FETCH_TUTOR_STATISTIC_SUCCESS,
  payload: {
    topSubjects,
  },
});

export const fetchTutorStatisticFailed = (errorMessage) => ({
  type: types.FETCH_TUTOR_STATISTIC_FAILED,
  payload: {
    errorMessage,
  },
});

const INIT_STATE = {
  loadingStatus: loadingStates.EMPTY,
  topSubjects: [],
};

export default function (state = INIT_STATE, action) {
  switch (action.type) {
    case types.FETCH_TUTOR_STATISTIC:
      return {
        ...state,
        loadingStatus: loadingStates.LOADING,
      };
    case types.FETCH_TUTOR_STATISTIC_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingStates.READY,
        topSubjects: action.payload.topSubjects,
      };
    case types.FETCH_TUTOR_STATISTIC_FAILED:
      return {
        ...state,
        loadingStatus: loadingStates.ERROR,
      };
    default:
      return state;
  }
}

export const getTutorTopSubjects = (state) =>
  state.chat.tutorStatics.topSubjects;



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/redux/tutorStatic.js